import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import styled from 'styled-components';
import { isBtoCFlow } from '__utils/common-utils';
import { useMediaQuery } from 'react-responsive';
import { CommonTitleDiv, WhiteCardWrapper, FormErrorMessageSpan, InputMintDiv, SuccessMessageSpan } from 'views/common-styled-components';
import { SuccessButton } from 'components/button';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import '../../../font-icon.css';
import { ProfileProgressStepsList } from 'constants/progress-steps-constants';
import OnboardingProgressSteps from 'components/onboarding-progress-steps';
import uploadImage from 'images/upload.png';
import { ENDPOINTS } from 'constants/endpoints';
import { fetchPost, getFormDataFromJson } from '__utils/ajax-wrapper';
import * as profileviewActions from '../profile-view.actions';
import { getEncryptedUserId } from '__utils/common-utils';
import { getDefaultHeaders, post, get } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import resolveURLParams from '__utils/url-params-resolver';
import ProfileViewSelector from '../profile-view.selector';
import CartSummary from 'components/cart-summary/index';
import { CommonStyledComponentProps } from '__utils/type';
import { useDeepCompare } from 'hooks/use-deep-memo';
import FileUpload from 'components/file-upload';
import PreviewImg from 'components/preview-image';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { Row, Col } from 'antd';
import './index.css';
import { LayoutContext } from 'components/app-routes';
import useFlashToggler from 'hooks/use-flash-toggler';
import CustomRadio from 'components/custom-radio';
import LoginSelector from 'views/login/login.selector';
import RiskProfileViewSelector from '../risk-profile/risk-profile.selector';

const BankDetailsWhiteCard = styled.div<CommonStyledComponentProps>`
    .updatePic{
        color: #00a465;
        cursor: pointer;
        margin-top: ${(props: any) => props.isMobile ? "10px" : "180px"};
    }
    
    `;
const BankDetailsSubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
        width: 164px;
        margin-top: 2rem; 
        font-size: 14px; 
        line-height: 20px;
        `;
const BankForm = styled.div <CommonStyledComponentProps>`
    width: ${(props: any) => props.isMobile ? '100%' : '73%'};  
    `;

const BankDetails: React.FC = () => {

    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();
    const dispatch = useDispatch();
    const [bank, setBank] = useState<any>();
    const [isChequeSubmitted, setIsChequeSubmitted] = useState<boolean>(false);
    const [chequePicUrl, setChequePicUrl] = useState<any>("");
    const [ifscError, setIfscError] = useState<boolean>(false);
    const [accountType, setAccountType] = useState<string>("");
    const { profileView } = propsToJS(useSelector(ProfileViewSelector));
    const [defaultValue, setDefaultValue] = useState<any>();
    const { register, handleSubmit, errors, setValue, trigger,getValues, watch } = useForm({ mode: 'onChange' });
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const [linkedBank, setLinkedBank] = useState(false);
    const [accNoInavlid, setAccNoInavlid] = useState(false);
    const [ifscInavlid, setIfscInavlid] = useState(false);
    const [showContinueBtn, setShowContinueBtn] = useState(false);
    const [loginUser, setLoginUser] = useState<any>();
    const [signzyBankUser, setSignzyBankUser] = useState<any>();

    const { currentUserDetails } = propsToJS(useSelector(LoginSelector));
    const { riskProfileResult } = propsToJS(useSelector(RiskProfileViewSelector));


    useEffect(() => {
        SetLayoutProps({
            config: { title: 'Investor Profile' }
        })
        dispatch(profileviewActions.fetchGetProfileView(getEncryptedUserId()));
        Mixpanel.track(getEventName("bankDetails", "loaded", "profile"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        })
    }, [linkedBank]);

    useEffect(() => {
        if(currentUserDetails && (profileView?.registeredWithBse !== 3)){
            bankLinkstatus();
        }
    }, [useDeepCompare(currentUserDetails)]);

    useEffect(() => {
        if (profileView) {
            setDefaultValue(profileView);
            if (profileView?.cancelledChequeURL) {
                if (profileView?.bankAccountNumber || profileView?.ifscCode) {
                    setChequePicUrl(profileView.cancelledChequeURL);
                    setIsChequeSubmitted(true);
                    if (profileView?.ifscCode) {
                        setBank(false);
                        checkIfValidIFSC(profileView?.ifscCode);
                    }
                    profileView?.bankAccountType && setAccountType(profileView?.bankAccountType);
                }
                else {
                    fetch(profileView?.cancelledChequeURL)
                        .then(async (response: any) =>
                            ({ blob: await response.blob(), fileType: response?.headers.get('content-type') ?? 'image/png' }))
                        .then(fileData => {
                            var file = new File([fileData.blob], "cheque.jpg", { type: fileData.fileType });
                            console.log("bank");
                            file && onChangeChequeImg(file, false);
                        }).catch((errors:any) => {
                            console.log(errors);
                        })
                }
                
            }

        }
    }, [useDeepCompare(profileView)]);

    const checkIfValidIFSC = (ifscInput: any) => {
        if (ifscInput && profileView?.registeredWithBse !== 3) {
            get(resolveURLParams(ENDPOINTS.GET_CHECK_IFSC, { ifsc: ifscInput }, null),
                getDefaultHeaders(),
                true
            ).subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.content?.length > 0) {
                    setIfscError(false);
                    setBank({ ...bank, name: response?.response?.content[0]?.bank, branch: response?.response?.content[0]?.branch });
                }
                else if (response?.response?.content?.length === 0) {
                    setIfscError(true);
                }

            }, (error: AjaxError) => {
                flash.error("Something went wrong. Please try again later.")
            });
        }
    }

    const onChangeChequeImg = async (chequeImg: any, shouldSetValue?: boolean) => {
        if (chequeImg && chequeImg.size > 5000000) {
            flash.error("Invalid file. You can upload image file of < 5mb size.");
        }
        else if (chequeImg) {
            Mixpanel.track(getEventName("cancelledChequeImageUpload", "clicked", "checkout"), {
                agentCode: getAgentCode(),
                user: getUserDetails(),
                isBtoCFlow: isBtoCFlow(),
            });
            const formData = new FormData();
            formData.append('file', chequeImg);
            fetchPost(
                ENDPOINTS.POST_CANCEL_UPLOAD_CHEQUE, formData, null, true
            ).then((response: any) => {
                if (response?.data?.cancelledChequeURL) {
                    setIfscError(false);
                    setChequePicUrl(response?.data?.cancelledChequeURL);
                    if (shouldSetValue) {
                        flash.success("File uploaded successfully");

                    }
                    setDefaultValue({ ...defaultValue, bankAccountNumber: response?.data?.bankAccountNumber, ifscCode: response.data?.ifscCode });
                    setValue("bankAccountNumber", response?.data?.bankAccountNumber);
                    trigger("bankAccountNumber");
                    setValue("ifscCode", response?.data?.ifscCode);
                    trigger("ifscCode");
                    setBank(false);
                    checkIfValidIFSC(response.data?.ifscCode);
                    setAccountType("");
                    setIsChequeSubmitted(true);
                }
                else {
                    flash.error("Can not upload file now. Please try later.");
                }
            }).catch((error: any) => {
                console.log("Can not upload file now. Please try later.");
            })
        }

    }
    const onSubmitBankDetails = (data: any) => {
        if (profileView?.registeredWithBse === 3) {
            history.push(
                riskProfileResult
                  ? "/profile/risk-profile-result?flowType=checkout"
                  : "/profile/risk-profile?flowType=checkout"
              );
        }
        else if (bank) {
            Mixpanel.track(getEventName("bankInfo", "completed", "checkout"), {
                agentCode: getAgentCode(),
                user: getUserDetails(),
                isBtoCFlow: isBtoCFlow(),

            });
            if (!linkedBank && !showContinueBtn) {
                linkBankAccount(data);
            }

            if (showContinueBtn || linkedBank) {
                const bankDetailsData = { ...profileView, ...{ cancelledChequeURL: chequePicUrl, bankAccountNumber: data?.bankAccountNumber, ifscCode: data?.ifscCode, bankAccountType: data?.bankAccountType } };
                post(resolveURLParams(ENDPOINTS.POST_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), bankDetailsData, getDefaultHeaders(), true)
                    .subscribe((response: AjaxResponse | AjaxError) => {
                        if (response.status === 200) {
                            history.push(
                                riskProfileResult
                                  ? "/profile/risk-profile-result?flowType=checkout"
                                  : "/profile/risk-profile?flowType=checkout"
                              );                        }
                        else {
                            flash.error("Something went wrong. Please try again later")
                        }
                    }, (error: AjaxError) => {
                        flash.error("Something went wrong. Please try again later")
                    })
            }
        }
    };

    const bankLinkstatus = () => {
        get(resolveURLParams(ENDPOINTS.GET_BANK_ACCOUNT_STATUS, {}, null),
            getDefaultHeaders(),
            true
        ).subscribe((response: AjaxResponse | AjaxError) => {
            if (response?.response?.data === true) {
                setShowContinueBtn(true)
            }
            else {
                setShowContinueBtn(false)
            }
        }, (error: AjaxError) => {
            console.log(error);
        });
    }
    

    const linkBankAccount = (data:any) => {
        const bankIfscDetails = getFormDataFromJson({
            accNo: data?.bankAccountNumber || profileView?.bankAccountNumber,
            ifsc: data?.ifscCode || profileView?.ifscCode
        });
        fetchPost(ENDPOINTS.POST_BANK_ACCOUNT_VERIFICATION, bankIfscDetails, null, true)
            .then((response: any) => {
                if (response?.meta?.message === "success") {
                    Mixpanel.track(getEventName("linkAccount", "clicked", "profile"), {
                        agentCode: getAgentCode(),
                        user: getUserDetails(),
                        isBtoCFlow: isBtoCFlow(),
        
                    });
                    setLinkedBank(true);
                    setLoginUser(response?.data?.loggedInUserName.toUpperCase()); 
                    setSignzyBankUser(response?.data?.userNameFromSignzy.toUpperCase());
                    flash.success("Account Link successfully!!")
                }
                else {
                    setLinkedBank(false);
                    setSignzyBankUser("");
                    if (response?.meta?.error === "Account") {
                        setAccNoInavlid(true);
                        flash.error("Bank account linking failed , please enter correct account details", 5000);
                    }
                    if (response?.meta?.error === "IFSC") {
                        setIfscInavlid(true);
                        flash.error("Bank account linking failed , please enter correct IFSC Code", 5000);
                    }
                    if (response?.meta?.error === "notActive") {
                        flash.error("Bank account linking failed , Because Bank Account is not Active", 5000);
                    }
                    if (response?.meta?.error === "serverDown") {
                        setShowContinueBtn(true);
                    }
                }
            }).catch((error: any) => {
                flash.error("Something went wrong. Please try again later")
            })
    }

    const prevBankDetailsChangeEnableBankLink = (e: any) => {
        setSignzyBankUser("");
        setIfscInavlid(false);
        setAccNoInavlid(false);        
        if (profileView?.ifscCode === getValues('ifscCode') && profileView?.bankAccountNumber === getValues('bankAccountNumber')) {
            setShowContinueBtn(true);
            setLinkedBank(true);
        } else {
            setShowContinueBtn(false);
            setLinkedBank(false);
        }
    }

    return (<div>
        <WhiteCardWrapper isMobile={isMobile} fullWidth>
            <BankDetailsWhiteCard isMobile={isMobile}>
                {!isMobile && <CartSummary />}
                {!isMobile && <CommonTitleDiv>Investor Profile</CommonTitleDiv>}
                <BankForm isMobile={isMobile}>
                    <OnboardingProgressSteps
                        stepsList={ProfileProgressStepsList}
                        currentStep={1}
                    />
                    <form name="bankDetailsForm" onSubmit={handleSubmit(onSubmitBankDetails)}>
                        <p>Take a picture or upload an existing picture of cancelled cheque of your bank account</p>
                        <br />
                        <div>

                            <FileUpload
                                name="cheque"
                                className="uploadImgCls"
                                id="uploadImgFile"
                                accept='image/*'
                                isUploaded={isChequeSubmitted}
                                onPictureUpload={onChangeChequeImg}
                                disabled={profileView?.registeredWithBse === 3}
                                style={{ marginLeft: "10px", float: "left" }}
                            >
                                <div className={ profileView?.registeredWithBse === 3 ? 'disabledlabelForFileInput':'labelForFileInput' }>
                                    <img src={uploadImage} alt="upload"></img>
                                    <p style={{ marginTop: "10px", lineHeight: "16px", textAlign: "center", fontSize: "14px" }}>Upload File</p>
                                </div>
                            </FileUpload>
                        </div>
                        {isChequeSubmitted && <PreviewImg
                            showUpdateDiv
                            id={"uploadImgFile"}
                            imgUrl={chequePicUrl}
                        />
                        }
                        <br />
                        {(isChequeSubmitted && profileView?.registeredWithBse !== 3) && <div>
                            <ul className="signzyLinkBankMsg">
                                <li>We will deposit ₹1 for FREE in your bank account to verify your bank details.</li>
                                <li>Please ensure that the name on your bank account is the same as the name on your PAN card.</li>
                            </ul>
                        </div>
                        }
                        {
                            isChequeSubmitted &&
                            <div>
                                {(loginUser !== signzyBankUser) && (signzyBankUser !== '') ? <p className="misMatchBankName"><b>* Oops!</b> Name on your account "<b>{signzyBankUser}</b>" and the Name on your PAN card is not matching. For a seamless experience, it's important to have consistent information. However, if you still want to proceed, just tap on the <b>Continue</b> button below.</p> : null}
                                <Row gutter={24}>
                                    <Col xs={24} md={10}>
                                        <InputMintDiv>
                                            <label htmlFor="bankAccountNumber">Bank Account Number</label>
                                            <br />
                                            <input
                                                className={accNoInavlid ? 'red' : ''}
                                                name='bankAccountNumber'
                                                type="text"
                                                placeholder="Enter Bank Account Number"
                                                defaultValue={defaultValue?.bankAccountNumber}
                                                disabled={profileView?.registeredWithBse === 3}
                                                style={{ marginTop: "10px" }}
                                                onChange={prevBankDetailsChangeEnableBankLink}
                                                // onBlur={(e: any) => setAccNoInput(e.target.value)}
                                                ref={register({
                                                    required: "Please enter your bank account number",
                                                    pattern: {
                                                        value: /^\d{9,18}$/,
                                                        message: "Please enter valid bank account number"
                                                    }

                                                })}
                                            />
                                            {(errors.bankAccountNumber) ? <FormErrorMessageSpan>{errors.bankAccountNumber.message}</FormErrorMessageSpan> : null}
                                        </InputMintDiv>
                                    </Col>
                                    <Col xs={24} md={10}>
                                        <InputMintDiv>
                                            <label htmlFor="investorIfscCode">Bank IFSC Code</label>
                                            <br />
                                            <input
                                                className={ifscInavlid ? 'red' : ''}
                                                name='ifscCode'
                                                type="text"
                                                placeholder="Enter IFSC Code"
                                                disabled={profileView?.registeredWithBse === 3}
                                                onMouseLeave={(e: any) => { checkIfValidIFSC(e.target.value) }}
                                                onKeyUp={(e: any) => { setIfscError(false); setBank(false) }}
                                                defaultValue={defaultValue?.ifscCode}
                                                onChange={prevBankDetailsChangeEnableBankLink}
                                                style={{ marginTop: "10px" }}
                                                ref={register({
                                                    required: "Please enter your IFSC Code",
                                                })}
                                            />
                                            {(errors.ifscCode) ? <FormErrorMessageSpan>{errors.ifscCode.message}</FormErrorMessageSpan> : null}
                                            {ifscError ? <FormErrorMessageSpan style={{ fontSize: "12px", marginBottom: " 0" }}>This IFSC does not exist in our system.</FormErrorMessageSpan>
                                                : bank ? <SuccessMessageSpan>{bank?.name} , {bank?.branch}</SuccessMessageSpan>
                                                    : null
                                            }
                                        </InputMintDiv>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} style={{ margin: '7px 0px' }}>
                                        <p>Account Type</p>
                                    </Col>
                                    <Col xs={24}>
                                        <div className="flex-row">
                                            <CustomRadio
                                                name='bankAccountType'
                                                label="Savings"
                                                value="Savings"
                                                checked={accountType === "Savings"}
                                                radiobuttonRef={register({
                                                    required: "Please enter your bank account type.",
                                                })}
                                                disabled={profileView?.registeredWithBse === 3}
                                                onChange={e => { setDefaultValue({ ...defaultValue, bankAccountType: e.currentTarget.value }); setAccountType(e.currentTarget.value); }}
                                            />
                                            <CustomRadio
                                                name='bankAccountType'
                                                label="Current"
                                                value="Current"
                                                radiobuttonRef={register({
                                                    required: "Please enter your bank account type.",
                                                })}
                                                checked={accountType === "Current"}
                                                disabled={profileView?.registeredWithBse === 3}
                                                onChange={e => { setDefaultValue({ ...defaultValue, bankAccountType: e.currentTarget.value }); setAccountType(e.currentTarget.value); }}
                                            />
                                        </div>
                                    </Col>
                                </Row><br />
                                {(errors.bankAccountType) ? <FormErrorMessageSpan>{errors.bankAccountType.message}</FormErrorMessageSpan> : null}

                                {!(errors.ifscCode || errors.bankAccountNumber) ? <BankDetailsSubmitButton type="submit" isMobile={isMobile}>{(profileView?.registeredWithBse === 3 || linkedBank || showContinueBtn) ? 'Continue' : 'Link bank account'}</BankDetailsSubmitButton> : null}

                                <br />
                            </div>
                        }
                    </form>
                </BankForm>
            </BankDetailsWhiteCard>
        </WhiteCardWrapper>

    </div>);
};

export default BankDetails;

